module.exports = "/_next/static/images/rv-powered-logo-e5d8c62da860685604a75508a23ed7ac.svg";